import { countIcon } from './icons';
import countBlockMeta from './block.json';
import edit from './edit';
import './style.scss';

const {
  blocks: { registerBlockType },
} = wp;

const { name, ...settings } = countBlockMeta;

const attributes = {
  ...settings.attributes,
};

registerBlockType(name, {
  ...settings,
  icon: countIcon,
  attributes,
  edit,
});
